<template>
  <div class="wrapp">
    <div
      class="section section-1"
      :style="{'border-left-color': item.mainColor}"
      v-for="(item,index) in imgList.category"
      :key="index"
    >
      <div class="head">
        <span class="icon" :class="'icon-'+item.icon" :style="{background:item.mainColor}"></span>
        {{item.title}}
      </div>
      <div class="bady grid col-item">
        <template v-for="(ite,ind) in imgList.list">
          <div class="item df" v-if="ite.category == item.id" :key="ind">
            <ImgWrapp
              :imgLink="ite.link"
              :ask="ite.ask"
              :isSelect="true"
              :bgColor="item.mainColor"
              :selected="ite.selected"
              :imgId="ite.id"
              @bindClick="selectImg"
              :info="{id:ite.id}"
            />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ImgWrapp from "../components/imgWrapp";
export default {
  props: {
    scrollTop: Number
  },
  components: { ImgWrapp },
  data() {
    return {};
  },
  methods: {
    selectImg(type, data) {
      this.$store.commit("selecteImg", {
        data: data.data,
        id: data.info.id
      });
    },
    showTips() {
      let _this = this;
      this.$my_message({
        type: "",
        title: "保存选片",
        btns: ["确认支付", "我再想想"],
        data: `
        <div class='text-20'>已保存选片<span class='text-24 text-orange'>25</span>张</div>
          <div class='text-18'>超过了套系约定精修<span class='text-orange'>20</span>张，将产生额外费用</div>
          <div class='text-28 text-orange'>￥100</div>
        `,
        success: function(data) {
          console.log("确认支付");
        }
      });
    }
  },
  computed: {
    imgList() {
      return this.$store.getters.getAllImgList;
    }
  },
  onLoad() {}
};
</script>

<style lang="scss" scoped>
.wrapp {
  .section {
    padding: 30px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid rgba(231, 233, 237, 1);
    margin-bottom: 20px;
    border-left: 5px solid;
    border-top: 0;
    .head {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: rgba(53, 64, 82, 1);
      .icon {
        width: 24px;
        height: 24px;
        background: rgba(255, 120, 0, 1);
        border-radius: 8px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 12px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        font-size: 14px;
      }
    }
    .bady {
      margin-top: 20px;
      width: 100%;
      max-width: 1300px;
      .item {
        margin-bottom: 10px;
      }
    }
  }
  .section:first-child {
    border-top-left-radius: 0;
  }
}
</style>
